import React, { memo, useCallback } from 'react'
import Input from '@sl/ui-library/molecules/Input'

const hasNumber = /\d/
const checkName = val => !hasNumber.test(val)
const nameCantBeEmpty = val => val.length !== 0

const NameInput = ({ state, setState }) => {
  const { clicked, valid, value } = state.userName
  const handleInput = useCallback(e => {
    const event = e
    const newVal = e.target.value || ''
    switch (event.type) {
      case 'click':
      case 'focus':
        setState(prev => ({
          ...prev,
          userName: {
            ...prev.userName,
            clicked: true,
          },
        }))
        break
      case 'blur':
        setState(prev => ({
          ...prev,
          userName: {
            ...prev.userName,
            valid: checkName(prev.userName.value) && nameCantBeEmpty(prev.userName.value),
          },
        }))
        break
      case 'change':
        setState(prev => ({
          ...prev,
          userName: {
            ...prev.userName,
            value: newVal,
            valid: checkName(newVal) && nameCantBeEmpty(newVal),
          },
        }))
        break
      default:
        break
    }
  }, [])
  const content = (
    <>
      <Input
        id="MooveFormLandingNameInput"
        onChange={handleInput}
        onBlur={handleInput}
        onClick={handleInput}
        onFocus={handleInput}
        error={clicked && !valid}
        success={valid}
        value={value}
        label="Nom"
        style={{ width: '100%' }}
      />
    </>
  )

  return content
}
export default memo(NameInput)
